import { EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Component, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-campaign-store-list',
  templateUrl: './campaign-store-list.component.html',
  styleUrls: ['./campaign-store-list.component.css', '../coupon-setup.scss']
})
export class CampaignStoreListComponent implements OnInit {
  showDialog = false;
  showAddStores = false;
  showAddGroup = false;
  dialogTitle: string;
  @Input() touchpoint: any;
  @Input() invalidSubmit: boolean;
  @Output() onTpStoresChanged: EventEmitter<any> = new EventEmitter();

  constructor(
    private translateService: TranslateService
  ) { }

  ngOnInit() {
  }

  openAddStores() {
    this.showAddStores = this.showDialog = true;
    this.dialogTitle = this.translateService.instant('campaign.add_stores');
  }

  openAddGroup() {
    this.showAddGroup = this.showDialog = true;
    this.dialogTitle = this.translateService.instant('campaign.addSavedGroup');
  }

  removeStore(store_id) {
    this.touchpoint.storesId = this.touchpoint.storesId.filter(item => parseInt(item) != store_id);
    this.touchpoint.stores = this.touchpoint.stores.filter(store => store.id != store_id);
    this.onTpStoresChanged.emit(this.touchpoint);
  }

  addStores(data: {addedStoresId: string[], addedStores: any[], selectedGroupsId?: string[]}) {
    this.touchpoint.storesId = data.addedStoresId;
    this.touchpoint.stores = data.addedStores;
    if (data.selectedGroupsId) {
      this.touchpoint.groupId = data.selectedGroupsId;
    }
    this.onTpStoresChanged.emit(this.touchpoint);
    this.closeDialog();
  }

  closeDialog() {
    this.showAddGroup =
    this.showAddStores =
    this.showDialog = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-store-list/campaign-store-list.component.ts